define('modules/start/products-report-model',['require','exports','module','env','base/model'],function(require, exports, module) {
    "use strict";

    var Config = require("env");
    var BaseModel = require("base/model");

    var Model = BaseModel.extend({
        url: function() {
            var url = Config.backendUrl + "/product-report";
            if (this.empId) {
                url = url + "/" + this.empId;
            }
            if (this.groupId) {
                url = url + "/group/" + this.groupId;
            }
            return url;
        },
        initialize: function() {
            this.initRequestEvents();
        },
        parse: function(response) {
            if (this.empId !== undefined && this.empId !== "0") {
                return response;
            }
            return response._embedded.product_report[0];
        },
        setEmpId: function(empId) {
            this.empId = empId;
        },
        setGroupId: function(groupId) {
            this.groupId = groupId;
        },
        getEmailProgressionLast7days: function() {
            return this.getProgression(this.get("email_users"), this.get("email_users_7days"));
        },
        getEmailProgressionLast30days: function() {
            return this.getProgression(this.get("email_users"), this.get("email_users_30days"));
        },
        getSMSProgressionLast7days: function() {
            return this.getProgression(this.get("sms_users"), this.get("sms_users_7days"));
        },
        getSMSProgressionLast30days: function() {
            return this.getProgression(this.get("sms_users"), this.get("sms_users_30days"));
        },
        getCookiesProgressionLast7days: function() {
            return this.getProgression(this.get("cookies_users"), this.get("cookies_users_7days"));
        },
        getCookiesProgressionLast30days: function() {
            return this.getProgression(this.get("cookies_users"), this.get("cookies_users_30days"));
        },
        getProgression: function(dataNow, dataBefore) {

            if (dataNow !== undefined && dataBefore !== undefined) {
                var now = parseInt(dataNow);
                var before = parseInt(dataBefore);
                if( before === 0) {
                    return 100;
                }
                return ( now * 100 / before) - 100;
            }
            return 0;
        },
        getEmailCtr: function() {
            if (this.get("email_openings") === 0) {
                return 0;
            }

            return this.get("email_clicks") * 100 / this.get("email_openings");
        },
        getEmailOpeningsPercent: function() {
            if (this.get("email_deliveries") === 0) {
                return 0;
            }

            return this.get("email_openings") * 100 / this.get("email_deliveries");
        },
        getLandingsConversionPercent: function() {
            if (this.get("landing_visits") === 0) {
                return 0;
            }

            return this.get("landing_conversion") * 100 / this.get("landing_visits");
        }
    });

    module.exports = Model;
});

